var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNetworkWorld = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  clipPath: "url(#network-world_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 22.5c5.799 0 10.5-4.701 10.5-10.5S17.799 1.5 12 1.5 1.5 6.201 1.5 12 6.201 22.5 12 22.5m0 1.5C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 22.5c2.821 0 5.5-4.592 5.5-10.5S14.821 1.5 12 1.5 6.5 6.092 6.5 12 9.179 22.5 12 22.5m0 1.5c-3.866 0-7-5.373-7-12S8.134 0 12 0s7 5.373 7 12-3.134 12-7 12"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12.75 16.5v-3.75H23v-1.5H12.75V7.5H22V6h-9.25V1h-1.5v5H2v1.5h9.25v3.75H1v1.5h10.25v3.75H2V18h9.25v5h1.5v-5H22v-1.5z",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "network-world_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export default SvgNetworkWorld;